import type { ReadonlyDeep } from 'type-fest';

import { ResolvableQuantityInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';
import type { ResolvableQuantityCmp_ResolvableQuantity } from '../../../components/ResolvableFields/ResolvableQuantity';

import { resolvableFloatForm2ApiMapper } from './resolvable-float.form2api.mapper';
import { resolvableIdForm2ApiMapper } from './resolvable-id.form2api.mapper';

export function resolvableQuantityForm2ApiMapper(
  resolvableQuantity: Readonly<ResolvableQuantityCmp_ResolvableQuantity>,
): ReadonlyDeep<ResolvableQuantityInput> {
  const resolvableQuantityInput = pruneInput(
    resolvableQuantity,
    ResolvableQuantityInput,
  );

  return {
    ...resolvableQuantityInput,
    value: resolvableFloatForm2ApiMapper(resolvableQuantity.value),
    unitId: resolvableIdForm2ApiMapper(resolvableQuantity.unitId),
  };
}
